import DOMPurify from "dompurify";

// SVG + IMG tags/attrs whitelisted so imported Form/Letter PDFs — whether
// rendered as inline SVG or embedded as base64 PNG pages — survive
// sanitisation with pixel-perfect layout intact.
const SVG_TAGS = [
  "svg", "g", "path", "text", "tspan", "rect", "line", "polyline",
  "polygon", "circle", "ellipse", "defs", "use", "symbol", "clipPath",
  "linearGradient", "stop", "image", "title", "desc",
];
const SVG_ATTRS = [
  "viewBox", "xmlns", "xmlns:xlink", "version", "preserveAspectRatio",
  "x", "y", "width", "height", "cx", "cy", "r", "rx", "ry",
  "x1", "y1", "x2", "y2", "d", "points",
  "transform", "clip-path", "clipPath", "clip-rule",
  "fill", "fill-opacity", "fill-rule", "stroke", "stroke-width",
  "stroke-opacity", "stroke-dasharray", "stroke-linecap", "stroke-linejoin",
  "font-family", "font-size", "font-weight", "font-style", "text-anchor",
  "letter-spacing", "opacity", "style", "xlink:href", "href",
  "src", "alt", "draggable", "contenteditable",
];

/**
 * Normalise legacy plain-text bodies (from before the rich editor) into HTML
 * so that <div dangerouslySetInnerHTML>, RichTextEditor and TipTap all render
 * predictably. If the body already looks like HTML, we just sanitise.
 */
export function toHtml(body) {
  const s = (body || "").trim();
  if (!s) return "";
  if (/<\/?[a-z][\s\S]*>/i.test(s)) return sanitize(s);
  // Plain text → paragraph-per-blank-line, <br> for single newlines
  const html = s
    .split(/\n{2,}/)
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br/>")}</p>`)
    .join("");
  return html;
}

export function sanitize(html) {
  return DOMPurify.sanitize(html || "", {
    ADD_TAGS: SVG_TAGS,
    ADD_ATTR: SVG_ATTRS,
  });
}

export function htmlToPlain(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body?.textContent || "").trim();
}

// Templates imported from a PDF with layout preserved contain either an
// embedded page image OR positioned SVG. Detect both.
export function isLayoutPreservedHtml(html) {
  const s = (html || "").trim();
  return s.startsWith('<div class="pdf-import"') ||
         /class="pdf-form-page"/.test(s) ||
         /<svg[\s>]/i.test(s);
}

function escapeHtml(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
